import { render, staticRenderFns } from "./SalePricesInstructions.vue?vue&type=template&id=533ae6c1&scoped=true"
import script from "./SalePricesInstructions.vue?vue&type=script&lang=js"
export * from "./SalePricesInstructions.vue?vue&type=script&lang=js"
import style0 from "./SalePricesInstructions.vue?vue&type=style&index=0&id=533ae6c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533ae6c1",
  null
  
)

export default component.exports